import { ComponentLike } from '@glint/template';
import { MainConditionInterface } from 'cio/app-models/conditions/abstract';
import { forEachSegmentable } from 'cio/utils/action-info';
import AttributeComponent from 'cio/components/cio-condition-viewer-attribute';
import EventAttributeComponent from 'cio/components/cio-condition-viewer-event-attribute';
import DeviceAttributeComponent from 'cio/components/cio-condition-viewer-device-attribute';
import EmailComponent from 'cio/components/cio-condition-viewer-email';
import EventComponent from 'cio/components/cio-condition-viewer-event';
import RelationshipComponent from 'cio/components/cio-condition-viewer-relationship';
import FormComponent from 'cio/components/cio-condition-viewer-form';
import PageviewComponent from 'cio/components/cio-condition-viewer-pageview';
import ScreenviewComponent from 'cio/components/cio-condition-viewer-screenview';
import ActionComponent from 'cio/components/cio-condition-viewer-action';
import UnknownComponent from 'cio/components/cio-condition-viewer-unknown';
import ActionCondition from 'cio/app-models/conditions/action';

const COMPONENT_NAMES: Record<string, ComponentLike<any>> = {
  attribute: AttributeComponent,
  event_attribute: EventAttributeComponent,
  device_attribute: DeviceAttributeComponent,
  email: EmailComponent,
  event: EventComponent,
  relationship: RelationshipComponent,
  form: FormComponent,
  pageview: PageviewComponent,
  screenview: ScreenviewComponent,
};

forEachSegmentable(function (action: string) {
  COMPONENT_NAMES[action] = ActionComponent;
});

const UNKNOWN_CONDITION_COMPONENT: ComponentLike<any> = UnknownComponent;

export function segmentViewComponent([condition]: [MainConditionInterface | ActionCondition | null]) {
  if (condition == null) {
    return UNKNOWN_CONDITION_COMPONENT;
  }

  return COMPONENT_NAMES[(condition as ActionCondition).uiType ?? condition.type] ?? UNKNOWN_CONDITION_COMPONENT;
}
